import React, { useEffect } from 'react';
import OtpVerificationForm from './OtpVerficationForm';
import { Modal} from "react-bootstrap";
import styles from "./account.module.scss"
import { useLocation } from 'react-router-dom';
import { PULSE_VIEW_ID, trackPulseView } from '../../analytics/pulseViewIds';

interface IOtpVerificationModal {
    displayOtpModal: boolean;
    setDisplayOtpModal: (boolean) => void;
    handleOtpVerification: (values, setSubmitting) => void;
    resendOtp: (setSubmitting) => void;
    userEmail: string;
    otpModalDescription: string;
    otpExpiryTime
}

const OtpVerificationModal: React.FC<IOtpVerificationModal> = ({
    displayOtpModal,
    setDisplayOtpModal,
    handleOtpVerification,
    resendOtp,
    userEmail,
    otpExpiryTime,
    otpModalDescription
}) => {
    const location = useLocation();

    useEffect(() => {
        if (!displayOtpModal) return;
        trackPulseView(PULSE_VIEW_ID.OTP_VERIFICATION_MODAL, {
            page_path: location.pathname,
        });
    }, [displayOtpModal, location.pathname]);

    const maskEmail = (email: string): string => {
        if (!email?.length) return;
        const [localPart, domain] = email.split('@');
        if (localPart.length <= 2) {
            return `${localPart[0]}***@${domain}`;
        }
        return `${localPart[0]}${'*'.repeat(localPart.length - 2)}${localPart.slice(
            -1,
        )}@${domain}`;
    };

    return (
        <Modal
            show={displayOtpModal}
            onHide={() => setDisplayOtpModal(false)}
            centered
            className="theme-modal-style app_container_wrap nor-padding border-radius-15"
        >
            <Modal.Header className="x-4">
                <button
                    type="button"
                    className="btn modal-close-button pe-0"
                    onClick={() => setDisplayOtpModal(false)}
                >
                    Close
                </button>
            </Modal.Header>
            <Modal.Body className="app_container_wrap px-1 py-2 text-center">
                <h3 className={` mt-4 mt-md-0 mb-4 ${styles.otpModalH3}`}>
                    {
                        otpModalDescription ?
                            otpModalDescription
                        :
                        `We have sent a 6-digit verification code to ${maskEmail(userEmail)}.`
                    }
                </h3>
                <OtpVerificationForm
                    handleOtpVerification={handleOtpVerification}
                    resendOtp={resendOtp}
                    userEmail={userEmail}
                    otpExpiry={otpExpiryTime}
                />
            </Modal.Body>
        </Modal>
    );
};

export default OtpVerificationModal;
